import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatPLN } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Building2, ClipboardList, Truck, Package, ArrowRightCircle, AlertTriangle } from "lucide-react";

function Kpi({ icon: Icon, label, value, to, testId }) {
  const inner = (
    <>
      <div className="flex items-center gap-2 mb-2 text-slate-500">
        <Icon className="w-4 h-4" />
        <p className="text-xs font-semibold uppercase tracking-wide">{label}</p>
      </div>
      <p className="text-3xl font-bold text-slate-900">{value}</p>
    </>
  );
  return to ? (
    <Link to={to} className="ol-kpi hover:border-[#FF6B1A] transition-colors block" data-testid={testId}>
      {inner}
    </Link>
  ) : (
    <div className="ol-kpi" data-testid={testId}>{inner}</div>
  );
}

export default function AdminDashboard() {
  const [summary, setSummary] = useState(null);

  useEffect(() => { api.get("/dashboard/summary").then((r) => setSummary(r.data)); }, []);

  if (!summary) return <div className="text-sm text-slate-500">Ładowanie…</div>;

  return (
    <div>
      <PageHeader testId="admin-dashboard" title="Dashboard Office-Land" subtitle="Przegląd portalu zakupowego NDI" />

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-6">
        <Kpi icon={Building2} label="Budowy NDI" value={summary.total_sites} to="/admin/sites" testId="kpi-sites" />
        <Kpi icon={ClipboardList} label="Zaakceptowane zamówienia" value={summary.approved_orders} to="/admin/orders" testId="kpi-approved" />
        <Kpi icon={ArrowRightCircle} label="Do realizacji" value={summary.pending_admin_action} to="/admin/orders" testId="kpi-pending" />
        <Kpi icon={Truck} label="W realizacji" value={summary.in_progress} to="/admin/orders" testId="kpi-in-progress" />
        <Kpi icon={Package} label="Zrealizowane" value={summary.completed} to="/admin/orders" testId="kpi-completed" />
      </div>

      <h2 className="text-lg font-semibold text-slate-900 mb-3 flex items-center gap-2"><Building2 className="w-4 h-4" /> Wszystkie budowy</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {summary.sites?.map((s) => {
          const pct = s.monthly_budget > 0 ? (s.used_budget_current_month / s.monthly_budget) * 100 : 0;
          const over = s.remaining < 0;
          return (
            <div key={s.id} className="ol-card p-5" data-testid={`admin-site-${s.id}`}>
              <div className="flex items-start justify-between">
                <div>
                  <p className="text-sm font-bold text-slate-900">{s.name}</p>
                  <p className="text-xs text-slate-500 mt-0.5">{s.approval_required_for_all_orders ? "Pełna akceptacja" : `Auto do ${formatPLN(s.auto_approve_limit)}`}</p>
                </div>
                {over && <AlertTriangle className="w-4 h-4 text-red-500" />}
              </div>
              <div className="mt-3">
                <div className="flex justify-between text-xs"><span className="text-slate-500">Budżet</span><span className="font-semibold">{formatPLN(s.monthly_budget)}</span></div>
                <div className="h-1.5 rounded-full bg-slate-100 overflow-hidden mt-1.5">
                  <div className={`h-full ${pct >= 100 ? "bg-red-500" : pct >= 80 ? "bg-amber-500" : "bg-emerald-500"}`} style={{ width: `${Math.min(pct, 100)}%` }} />
                </div>
                <div className="flex justify-between text-xs mt-1.5">
                  <span className="text-slate-500">Wykorzystano</span>
                  <span className="font-semibold">{formatPLN(s.used_budget_current_month)}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
